<template>
  <div class="main-events d-flex ml-2">
    <div v-for="(event, i) in mainEvents" :key="event.id_event">
      <div class="pa-2 pl-0">
        <MainEventCard :event="event" :index="i" />
      </div>
    </div>
  </div>
</template>

<script>
import MainEventCard from "./MainEventCard.vue";

export default {
  name: "MobileMainEvents",
  props: ["mainEvents"],
  components: { MainEventCard },
};
</script>
<style>
.main-events {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;
}
.main-events::-webkit-scrollbar {
  display: none;
  width: 0px;
  background: transparent;
}
</style>
